module.exports = __webpack_public_path__ + "img/lou.72a7f082.png";